import { CustomXPFieldConfig } from '@kyruus/types';
/**
 * Returns an array of sections in the desired order, excluding any specified sections.
 */
export function getRenderableSections({
  defaultSections,
  sectionOrder,
  excludedSections,
  customXPFieldSections
}: {
  defaultSections: string[];
  sectionOrder?: string[];
  excludedSections?: string[];
  customXPFieldSections?: CustomXPFieldConfig[];
}) {
  let sections: string[] = [];
  const customSections = customXPFieldSections
    ? customXPFieldSections?.map((customSection) => customSection.id)
    : [];
  if (Array.isArray(sectionOrder)) {
    // use the order as passed in
    sections = [...sectionOrder];
    // and append any section from defaultSections that wasnt in sectionOrder
    defaultSections.forEach((section: string) => {
      if (!sections.includes(section)) {
        sections.push(section);
      }
    });
    customSections.forEach((section: string) => {
      if (!sections.includes(section)) {
        sections.push(section);
      }
    });
  } else {
    sections = [...defaultSections, ...customSections];
  }

  if (Array.isArray(excludedSections)) {
    // filter out any sections that are in the excludedSections array
    return sections.filter(
      (section: string) => !excludedSections.includes(section)
    );
  }

  return sections;
}
